/*
  Fabriq 2026-10-10 : accessoires offerts ajoutés automatiquement au panier (remplace CartBot).

  La règle vit sur chaque variante de machine, dans l'admin Shopify :
    - custom.cadeaux_promo     : variantes offertes avec cette machine
    - custom.cadeaux_promo_fin : dernier jour de la promo (après, plus rien ne s'ajoute)
  Le 0 $ vient du rabais automatique Shopify « achetez X, obtenez Y » créé pour la promo.

  Les lignes ajoutées portent la propriété cachée _cadeau_de (la variante de la machine) :
  elles repartent avec la machine. Le thème cache déjà les propriétés qui commencent par « _ ».
*/
(function () {
  if (window.tfCadeaux) return;

  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartes = {};
  var enCours = null;
  var aRefaire = false;
  var nousMemes = false;
  var refuses = {}; // accessoires refusés par Shopify (rupture…) : pas de nouvel essai sur cette page

  function deuxChiffres(n) { return (n < 10 ? '0' : '') + n; }
  function aujourdHui() {
    var d = new Date();
    return d.getFullYear() + '-' + deuxChiffres(d.getMonth() + 1) + '-' + deuxChiffres(d.getDate());
  }
  function lireJson(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, options || {})).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }
  function envoyer(chemin, corps) {
    return fetch(racine + chemin, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    });
  }

  // Règles d'une fiche : { "<variante machine>": { c: [variantes offertes], f: "AAAA-MM-JJ" } }
  function regles(handle) {
    if (!cartes[handle]) {
      cartes[handle] = fetch(racine + 'products/' + encodeURIComponent(handle) + '?view=cadeaux', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { try { return JSON.parse(t).v || {}; } catch (e) { return {}; } })
        .catch(function () { return {}; });
    }
    return cartes[handle];
  }

  function estCadeau(ligne) { return !!(ligne.properties && ligne.properties._cadeau_de); }

  // Sections du panier que le thème redessine (même logique que le thème).
  function idsSections() {
    var ids = [];
    var page = document.querySelector('xo-cart');
    var mini = document.querySelector('xo-cart-mini');
    if (location.pathname.indexOf('/cart') !== -1 && page && page.id) ids.push(page.id);
    if (mini && mini.id) ids.push(mini.id);
    return ids;
  }

  async function rafraichir() {
    var panier = await lireJson(racine + 'cart.js');
    var ids = idsSections();
    var magasin = window.xoStore;
    if (!ids.length || !magasin) return;
    var sections = await lireJson(racine + '?sections=' + ids.join(','));
    nousMemes = true;
    try {
      magasin.set('xo-cart', function (avant) {
        return Object.assign({}, avant, { size: panier.item_count, sections: sections });
      })('tf/cadeaux');
    } finally {
      nousMemes = false;
    }
  }

  async function travailler() {
    var panier = await lireJson(racine + 'cart.js');
    var jour = aujourdHui();
    var voulus = {};
    var ordre = [];
    var machines = panier.items.filter(function (l) { return !estCadeau(l); });
    for (var i = 0; i < machines.length; i++) {
      var ligne = machines[i];
      var regle = (await regles(ligne.handle))[String(ligne.variant_id)];
      if (!regle || !regle.c || !regle.c.length) continue;
      if (regle.f && regle.f < jour) continue;
      regle.c.forEach(function (g) {
        g = String(g);
        if (!voulus[g]) { voulus[g] = String(ligne.variant_id); ordre.push(g); }
      });
    }
    var cadeaux = panier.items.filter(estCadeau);
    var aAjouter = ordre.filter(function (g) {
      return !refuses[g] && !cadeaux.some(function (c) { return String(c.variant_id) === g; });
    });
    var aRetirer = cadeaux.filter(function (c) { return !voulus[String(c.variant_id)]; });
    if (!aAjouter.length && !aRetirer.length) return false;

    for (var j = 0; j < aRetirer.length; j++) {
      await envoyer('cart/change.js', { id: aRetirer[j].key, quantity: 0 });
    }
    // Un à la fois : un accessoire en rupture ne bloque pas les autres.
    for (var k = 0; k < aAjouter.length; k++) {
      var reponse = await envoyer('cart/add.js', {
        items: [{ id: Number(aAjouter[k]), quantity: 1, properties: { _cadeau_de: voulus[aAjouter[k]] } }]
      });
      if (!reponse.ok) refuses[aAjouter[k]] = true;
    }
    await rafraichir();
    return true;
  }

  function synchroniser() {
    if (enCours) { aRefaire = true; return enCours; }
    enCours = travailler()
      .catch(function (e) { if (window.console) console.warn('tf-cadeaux', e); return false; })
      .then(function (resultat) {
        enCours = null;
        if (aRefaire) { aRefaire = false; return synchroniser(); }
        return resultat;
      });
    return enCours;
  }

  // Après chaque changement du panier fait par le thème (ajout, quantité, retrait).
  var minuterie = null;
  function planifier() {
    if (nousMemes) return;
    clearTimeout(minuterie);
    minuterie = setTimeout(synchroniser, 250);
  }

  // Fabriq 2026-10-11 : panier vide au chargement = rien à ajouter ni à retirer, donc aucune
  // lecture de /cart.js. Le nombre vient du serveur, comme la pastille du thème : premier
  // <xo-cart-size> de l'en-tête ({{ cart.item_count }}), avec le même repli que getCartSize du
  // thème (lignes du mini-panier). Au moindre doute (pastille absente ou illisible), on lit le
  // panier comme avant. L'ajout et le retrait automatiques ne changent pas : au premier ajout,
  // l'abonnement xo-cart ci-dessous déclenche la synchro.
  function panierVideAuChargement() {
    var pastille = document.querySelector('xo-cart-size');
    if (!pastille) return false;
    var texte = (pastille.textContent || '').trim();
    if (!/^\d+$/.test(texte) || Number(texte) !== 0) return false;
    var mini = document.querySelector('xo-cart-mini');
    return !(mini && mini.querySelector('xo-product[xo-line]'));
  }

  function brancher() {
    if (window.xoStore && window.xoStore.subscribe) {
      var tailleConnue = null;
      window.xoStore.subscribe('xo-cart', function (etat) {
        if (!etat) return;
        // Le nombre d'articles change à chaque ajout, quantité ou retrait.
        if (tailleConnue !== null && etat.size !== tailleConnue) planifier();
        tailleConnue = etat.size;
      });
    }
    if (!panierVideAuChargement()) synchroniser();
  }

  window.tfCadeaux = { synchroniser: synchroniser };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
